import { send } from '../../../../src/network';
import { type PaginatedBundleModifyReasonList } from '../../../../src/types/PaginatedBundleModifyReasonList';

export { type BundleModifyReason } from '../../../../src/types/BundleModifyReason';

type Params = {
  limit?: number;
  offset?: number;
};

export async function getApiV2BundleModifyReasons(params: Params = {}) {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  return await send<PaginatedBundleModifyReasonList>({
    path: '/api/v2/bundle_modify_reasons/',
    method: 'GET',
    query: queryParams,
  });
}
